import { ReactComponent as ArrowLeftSvg } from '../../assets/arrow-left.svg';

import { IconWrapper } from './iconWrapper';
import { IconProps } from './model';

export const ArrowLeftIcon = (props: IconProps) => {
    return (
        <IconWrapper {...props}>
            <ArrowLeftSvg />
        </IconWrapper>
    );
};
